import { auth } from "@/firebase";
import axios from "axios";
import api from "./url-address";

const instance = axios.create({
  baseURL: api.baseURL,
  headers: {
    "Content-type": "application/json",
  },
});

// ฟังก์ชันเพื่อดึง token ล่าสุด และบังคับรีเฟรชเมื่อเหลือน้อยกว่า 5 นาที
const getFreshToken = async (user) => {
  if (!user) return null;
  
  try {
    // ดึง token result ปัจจุบันมาดูเวลาก่อน
    const tokenResult = await user.getIdTokenResult();
    const expirationTime = new Date(tokenResult.expirationTime).getTime();
    const currentTime = Date.now();

    // 👉 เช็คเงื่อนไข: ถ้าเหลือเวลาน้อยกว่า 5 นาที (5 * 60 * 1000 มิลลิวินาที)
    if (expirationTime - currentTime < 5 * 60 * 1000) {
      console.log("Token กำลังจะหมดอายุใน 5 นาที -> ทำการบังคับรีเฟรชใหม่เบื้องหลัง");
      return await user.getIdToken(true); // สั่งรีเฟรชทันที
    }
    
    return tokenResult.token;
  } catch (error) {
    console.error("Error getting token:", error);
    return null;
  }
};

// ตั้งค่า Axios Request Interceptor (ตัวดักก่อนยิง API)
instance.interceptors.request.use(
  async (config) => {
    // ให้ Firebase รอโหลดสถานะผู้ใช้เริ่มต้นจาก LocalStorage แป๊บหนึ่งถ้าเพิ่งเปิดหน้าเว็บ
    await auth.authStateReady(); 
    
    const user = auth.currentUser;
    if (user) {
      const token = await getFreshToken(user);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        delete config.headers.Authorization;
      }
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 💡 เอาบล็อก onAuthStateChanged เก่าออกได้เลยครับ 
// เพราะลำพังแค่ Request/Response Interceptor ก็ครอบคลุมการแนบ Token สดใหม่ทุกวินาทีแล้ว

// จัดการ response error (กรณีหลุดคิว หรือมีปัญหา Error 401 ในจังหวะอื่น)
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      auth.currentUser
    ) {
      originalRequest._retry = true; 
      // บังคับเปลี่ยนใบใหม่ทันทีถ้าระบบส่ง 401 กลับมา
      const token = await auth.currentUser.getIdToken(true); 
      if (token) {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return instance(originalRequest); 
      }
    }
    return Promise.reject(error);
  }
);

export default instance;